import store from '@/store'
import { useRoute } from 'vue-router'
import router from '@/router'
import { ItemSearchQuery } from '@/store/modules/url'

export function useUrlFunc() {

  function getUrlQuery(key: string): any {
    const route = useRoute()
    return route.query[key]
  }

  function initItemSearchQueries() {
    const queries: ItemSearchQuery = {
      cat: [],
      l: [],
      d: [],
      s: undefined,
    }
    store.commit('url/setItemSearchQuery', queries)
  }

  function getItemSearchQueries() {
    const itemSearchQuery = store.getters['url/itemSearchQuery']
    if (!itemSearchQuery) {
      initItemSearchQueries()
    }

    return store.getters['url/itemSearchQuery']
  }
  function getS(): string | undefined {
    const itemSearchQuery = getItemSearchQueries()
    let res: string | undefined = undefined
    if (itemSearchQuery) {
      const s = itemSearchQuery.s
      if (s) {
        if ( typeof(s) === 'string' ) {
          res = s
        } else {
          res = s as string
        }
      }
    }
    return res
  }

  function saveS(s: string | undefined) {
    const itemSearchQuery = getItemSearchQueries()
    if (itemSearchQuery) {
      itemSearchQuery.s = s ? s : undefined
      store.commit('url/setItemSearchQuery', itemSearchQuery)
  
      // router.push({query: itemSearchQuery})
    }
  }


  function getCat(): number[] | undefined {
    const itemSearchQuery = getItemSearchQueries()
    let res: number[] = []
    if (itemSearchQuery) {
      const cat = itemSearchQuery.cat
      if (cat) {
        if ( typeof(cat) === 'string' ) {
          res.push(parseInt(cat))
        } else {
          res = cat.map((c: string) => parseInt(c)) as number[]
        }
      }
    }
    return res
  }

  function saveCat(cat: number[] | undefined) {
    const itemSearchQuery = getItemSearchQueries()
    if (itemSearchQuery) {
      itemSearchQuery.cat = cat ? cat : []
      store.commit('url/setItemSearchQuery', itemSearchQuery)
  
      // router.push({query: itemSearchQuery})
    }
  }

  function getD(): string[] | undefined {
    const itemSearchQuery = store.getters['url/itemSearchQuery']
    let res: string[] = []
    if (itemSearchQuery) {
      const d = itemSearchQuery?.d
      if (d) {
        if ( typeof(d) === 'string' ) {
          res.push(d)
        } else {
          res = d as string[]
        }
      }
    }
    return res
  }
  function saveD(d: string[] | undefined) {
    const itemSearchQuery = getItemSearchQueries()
    if (itemSearchQuery) {
      itemSearchQuery.d = d ? d : []
      store.commit('url/setItemSearchQuery', itemSearchQuery)
  
      // router.push({query: itemSearchQuery})
    }
  }

  function getL(): string[] | undefined {
    const itemSearchQuery = store.getters['url/itemSearchQuery']
    let res: string[] = []
    if (itemSearchQuery) {
      const l = itemSearchQuery?.l
      if (l) {
        if ( typeof(l) === 'string' ) {
          res.push(l)
        } else {
          res = l as string[]
        }
      }
    }
    return res
  }
  function saveL(l: string[] | undefined) {
    const itemSearchQuery = getItemSearchQueries()
    if (itemSearchQuery) {
      itemSearchQuery.l = l ? l : []
      store.commit('url/setItemSearchQuery', itemSearchQuery)
  
      // router.push({query: itemSearchQuery})
    }
  }
  /**
   * エラーページを表示する
   */
  function show500(message?: string) {
    // リダイレクト
    router.push({
      name: 'InternalServerError',
      query: {
        message: message
      }
    })
  }

  return {
    getUrlQuery,
    getS,
    saveS,
    getCat,
    saveCat,
    getD,
    saveD,
    getL,
    saveL,
    show500,
    getItemSearchQueries,
  }
}
